import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import TrafficTimeService from '@app/services/trafficTime.service';
import { Button } from '@app/components/index';

function formatoFecha(fecha) {
    if (!fecha) return '-';
    try {
        const d = new Date(fecha);
        return d.toLocaleString('es-AR');
    } catch (_) {
        return String(fecha);
    }
}

function ModalTrafficTimeHistorial({ show, hideModal, item }) {
    const [isLoading, setIsLoading] = useState(false);
    const [historial, setHistorial] = useState([]);

    useEffect(() => {
        if (!show || !item) return;
        setIsLoading(true);
        TrafficTimeService.getHistorial({
            segmento: item.segmento_tt,
            gravedad: item.gravedad_tt
        })
            .then((res) => setHistorial(res || []))
            .finally(() => setIsLoading(false));
    }, [show, item]);

    return (
        <Modal show={show} backdrop="static" onHide={hideModal} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    Historial Traffic Time
                    {item ? ` - ${item.segmento_tt} / ${item.gravedad_tt}` : ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (
                    <div className="text-center p-3">
                        <span className="spinner-border spinner-border-sm mr-2" />
                        Cargando...
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th rowSpan={2} className="align-middle">#</th>
                                    <th rowSpan={2} className="align-middle">Segmento</th>
                                    <th rowSpan={2} className="align-middle">Gravedad</th>
                                    <th colSpan={4} className="text-center bg-light">Capital</th>
                                    <th colSpan={4} className="text-center bg-light">Interior</th>
                                    <th rowSpan={2} className="align-middle">Estado</th>
                                    <th rowSpan={2} className="align-middle">Creado por</th>
                                    <th rowSpan={2} className="align-middle">Creado</th>
                                    <th rowSpan={2} className="align-middle">Actualizado</th>
                                </tr>
                                <tr>
                                    <th style={{color:'#28a745'}}>Verde</th>
                                    <th style={{color:'#c99a07'}}>Amarillo</th>
                                    <th style={{color:'#fd7e14'}}>Naranja</th>
                                    <th style={{color:'#dc3545'}}>Rojo</th>
                                    <th style={{color:'#28a745'}}>Verde</th>
                                    <th style={{color:'#c99a07'}}>Amarillo</th>
                                    <th style={{color:'#fd7e14'}}>Naranja</th>
                                    <th style={{color:'#dc3545'}}>Rojo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historial.length === 0 && (
                                    <tr>
                                        <td colSpan={15} className="text-center text-muted">Sin historial</td>
                                    </tr>
                                )}
                                {historial.map((h) => (
                                    <tr key={h.id_tt} className={h.isDeleted_tt ? 'text-muted' : ''}>
                                        <td>{h.id_tt}</td>
                                        <td>{h.segmento_tt}</td>
                                        <td>{h.gravedad_tt}</td>
                                        <td>{h.nivelVerdeHoursCapital_tt ?? '-'}</td>
                                        <td>{h.nivelAmarilloHoursCapital_tt ?? '-'}</td>
                                        <td>{h.nivelNaranjaHoursCapital_tt ?? '-'}</td>
                                        <td>{h.nivelRojoHoursCapital_tt ?? '-'}</td>
                                        <td>{h.nivelVerdeHours_tt ?? '-'}</td>
                                        <td>{h.nivelAmarilloHours_tt ?? '-'}</td>
                                        <td>{h.nivelNaranjaHours_tt ?? '-'}</td>
                                        <td>{h.nivelRojoHours_tt ?? '-'}</td>
                                        <td>
                                            {h.isDeleted_tt
                                                ? <span className="badge badge-secondary">HISTORICO</span>
                                                : <span className="badge badge-success">ACTIVO</span>}
                                        </td>
                                        <td>
                                            {h.creadoPor?.nombre_p
                                                ? (
                                                    <span>
                                                        <i className="fas fa-user mr-1 text-muted" />
                                                        {h.creadoPor.nombre_p}
                                                    </span>
                                                )
                                                : <span className="text-muted">-</span>}
                                        </td>
                                        <td>{formatoFecha(h.createdAt)}</td>
                                        <td>{formatoFecha(h.updatedAt)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button theme="default" onClick={hideModal}>
                    CERRAR
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ModalTrafficTimeHistorial.defaultProps = {
    show: false,
    item: null
};

export default ModalTrafficTimeHistorial;
